<button [attr.id]="'btnDialogClose'" mat-button mat-dialog-close>
  <mat-icon>close</mat-icon>
</button>

<h1 mat-dialog-title>{{ 'intervention-instance.modal_delete_instance_title' | translate:param }}</h1>

<div mat-dialog-content>
  <app-instance-deletion
    [_intervention]="intervention"
    [_instance]="instance"
    [_collaborators]="collaborators"
    [_members]="members"
    (emitAcceptDeletion)="changeAcceptDeletion($event)"
  ></app-instance-deletion>
  <div *ngIf="buddyError" class="buddyErrorDiv">
    {{ 'intervention-instance.modal_delete_instance_buddy_error' | translate:buddyParam }}
  </div>
</div>
<div mat-dialog-actions align="end">
  <button [attr.id]="'btnCancel'" mat-button mat-dialog-close="CANCELED">
    {{ 'intervention-instance.modal_cancel' | translate }}
  </button>
  <app-button-feedback
    [_setId]="'btnSetDeleted'"
    (click)="deleteInstance()"
    [_defaultButtonText]="'intervention-instance.modal_delete_instance'"
    [_responseText]="(setDeletionResponse | async)"
    [_isDisabled]="isDisabled()"
  ></app-button-feedback>
</div>
